import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from './auth/authentication.service';

//import { MatSnackBar } from '@angular/material/snack-bar';
import { Gtp } from '../shared/gtp';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        //private snackBar: MatSnackBar
        private gtp: Gtp
    ) { }
    //https://scotch.io/bar-talk/error-handling-with-angular-6-tips-and-best-practices192#toc-the-shortcomings-of-errorhandler
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            let errorMessage = '';
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                //location.reload(true);
            }
            if (err.status === 500) {
                if (err.error instanceof ErrorEvent) {
                    // client-side error
                    console.log(`Error: ${err.error.message}`);
                } else {
                    // server-side error
                    console.log(`Error Code: ${err.status}\nMessage: ${err.message}`);
                }
                this.gtp.errorNotif();
            }
            if (err.status === 404) {
                this.gtp.errorNotif('vacio');
            }
            const error = (err.error && err.error.message) ? err.error.message : (err.statusText || 'Error desconocido');
            return throwError(error);
        }))
    }
}
